var logger = function logger(...messages){
    //if(process.env.NODE_ENV === 'production') return;
    if(process.env.REACT_APP_ENABLE_LOGS.toUpperCase()==='FALSE') return
        console.log(messages);
}
exports.logger = logger;